export const locales = {
	greaterThanTo: 'La date saisie doit être supérieure à la date de début.'
};
